<template>
    <el-dialog title="问题封闭" :close-on-click-modal="false" :visible.sync="visible" width="1000px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="155px" :inline="true"
            class="border-form" style="margin-right: 25px;">
            <!-- <el-row class="set_border"> -->
            <!-- <el-col :span="12" class="col-set_border">
                    <el-form-item label="标的物" class="item">
                        <span class="set_data">{{ dataForm.subjectName }}</span>
                    </el-form-item>
                </el-col> -->
            <!-- <el-col :span="8" class="set_border">
                    <el-form-item label="范畴" class="item">
                        {{ dataForm.categoryName }}
                    </el-form-item>
                </el-col> -->
            <!-- <el-col :span="12">
                    <el-form-item label="专业" class="item">
                        <span class="set_data">{{ dataForm.majorName }}</span>
                    </el-form-item>
                </el-col> -->
            <!-- </el-row> -->
            <!-- <el-row class="set_border">
                <el-col :span="12" class="col-set_border">
                    <el-form-item label="提出人" class="item">
                        <span class="set_data">{{ dataForm.inspectionMan }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="提出时间" class="item">
                        <span class="set_data">{{ dataForm.inspectionTime | formatDate('yyyy-MM-dd') }}</span>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <!-- <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="巡检内容" class="item">
                        <span class="set_data">{{ dataForm.inspectionContent }}</span>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <!-- <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="问题描述及整改意见" class="item">
                        <span class="set_data">{{ dataForm.sutContent }}</span>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row>
                <el-col :span="24" class="row-form-item">
                    <el-form-item label="问题描述及整改意见（如有时）" class="fileItem">
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="24">
                    <div class="set_data">{{ dataForm.sutContent }}</div>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="12" class="col-set_border">
                    <el-form-item label="封闭人" class="item">
                        <!-- <span class="set_data">{{ dataForm.closeMan }}</span> -->
                        <el-input v-model="dataForm.closeMan" class="no-border-input"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="col-set_border">
                    <el-form-item label="封闭时间" class="item">
                        <el-date-picker v-model="dataForm.closeTime" type="date" value-format="yyyy-MM-dd"
                            placeholder="选择日期" :clearable="false" class="no-border-input">
                        </el-date-picker>
                        <!-- <span class="set_data">{{ dataForm.closeTime | formatDate('yyyy-MM-dd') }}</span> -->
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="row-form-item">
                    <el-form-item label="封闭状况描述（如有时）" class="fileItem">
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="24">
                    <!-- <span class="set_data">{{ dataForm.closeOpinion }}</span> -->
                    <el-input type="textarea" :rows="4" v-model="dataForm.closeOpinion" class="no-border-input">
                    </el-input>
                </el-col>
            </el-row>
            <!-- <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="备注" class="item">
                        <span class="set_data">{{ dataForm.remark }}</span>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row>
                <el-row>
                    <el-col :span="24" class="row-form-item">
                        <div class="fileItem">封闭时照片（如有时）</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" style="margin-top: 10px;">
                        <el-upload ref="uploadImg" class="upload-demo-photo" action="action" drag :before-upload="beforeUploadSituation"
                            :http-request="uploadImg" multiple :show-file-list=false :auto-upload="true"
                            accept="image/jpeg,image/png,image/jpg">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                        </el-upload>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" style="margin-top: 30px;margin-bottom: 10px;">
                        <el-table class="dataListTable" border header-align="center"
                            v-if="dataForm.closePhotoList.length > 0" :data="dataForm.closePhotoList"
                            style="width: 100%;" :cell-style="{ padding: '0px' }">
                            <el-table-column type="index" label="No." width="60" header-align="center" align="center">
                            </el-table-column>
                            <el-table-column label="图片" width="220" header-align="center">
                                <template slot-scope="scope">
                                    <el-image style="height: 100px" :src="scope.row.thumbnailPathUri"
                                        :preview-src-list="previewList(scope.row.thumbnailPathUri)"
                                        fit='contain'></el-image>
                                </template>
                            </el-table-column>
                            <el-table-column label="描述" width="450px" header-align="center">
                                <template slot-scope="scope">
                                    <el-input type="textarea" rows="2"
                                        v-model="dataForm.closePhotoList[scope.$index].fileContent"
                                        placeholder="请填写"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label=" " width="103" align="center">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="danger"
                                        @click="delClosePhoto(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="同步" width="80" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-checkbox :value="scope.row.synchroFlg === 1"
                                        @change="(val) => (scope.row.synchroFlg = val ? 1 : 0)" class="sbox"
                                        label=""></el-checkbox>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="row-form-item">
                        <div class="fileItem">封闭时附件（如有时）</div>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px;">
                    <el-col :span="8">
                        <el-upload ref="uploadFile" class="upload-demo" action="action" drag :http-request="uploadFile"
                            multiple :show-file-list=false :auto-upload="true">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        </el-upload>
                    </el-col>
                    <el-col :span="16">
                        <el-table :data="dataForm.closeFileList" :cell-style="{ padding: '0px' }"
                            style="margin-bottom: 20px;" :show-header="false"
                            v-if="dataForm.closeFileList && dataForm.closeFileList.length > 0">
                            <el-table-column width="100" align="center" type="index">
                            </el-table-column>
                            <el-table-column prop="fileName" width="350" align="center">
                                <template slot-scope="scope">
                                    <el-input class="sp-input" v-model="scope.row.fileName"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column width="150" align="center">
                                <template slot-scope="scope">
                                    <el-button v-preventReClick type="text" size="small"
                                        @click="selectFile(scope.row.fileUri, scope.row.fileName)">查看</el-button>
                                    <el-button v-preventReClick type="text" size="small"
                                        @click="delCloseFile(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </el-row>
            <el-row class="formBtnGroup">
                <el-button v-preventReClick class="btn" type="primary" size="small"
                    @click="dataFormSubmit()">确定</el-button>
                <!-- <el-button v-preventReClick class="btn" type="primary" size="small"
                    @click="cancelClose()">取消封闭</el-button> -->
                <el-button v-preventReClick class="btn" type="primary" size="small"
                    @click="visible = false">取消</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
    name: "patrolList-add-or-update",
    data() {
        return {
            inspectionId: '',
            closeFlg: false,
            dataForm: {
                scenePhotoList: [],
                closeFileList: [],
                closePhotoList: [],
                inspectionId: ''
            },
            dataRule: {},
            visible: false
        };
    },
    components: {

    },
    activated() {

    },
    filters: {
        formatDate: function (value, args) {
            if (!value) {
                return ''
            }
            var dt = new Date(value);
            if (args == 'yyyy-M-d') {// yyyy-M-d
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                return `${year}-${month}-${date}`;
            } else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                let hour = dt.getHours();
                let minute = dt.getMinutes();
                let second = dt.getSeconds();
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            } else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${date}`;
            } else {// yyyy-MM-dd HH:mm:ss
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                let hour = dt.getHours().toString().padStart(2, '0');
                let minute = dt.getMinutes().toString().padStart(2, '0');
                let second = dt.getSeconds().toString().padStart(2, '0');
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            }
        }
    },
    methods: {
        init(id) {
            this.inspectionId = id;
            this.visible = true;
            this.dataForm = {
                scenePhotoList: [],
                closeFileList: [],
                closePhotoList: [],
                inspectionId: this.inspectionId
            }
            this.getDetail(id)
        },
        previewList(fileUri) {
            return [fileUri]
        },
        // getDetail() {
        //     this.$http({
        //         url: this.$store.state.httpUrl + "/business/inspectionfile/list/" + this.inspectionId,
        //         method: "get",
        //         params: {},
        //     }).then(({ data }) => {
        //         if (data && data.resultCode === 200) {
        //             this.dataForm = data.body
        //         }
        //     });
        // },
        selectFile(url, filename) {
            filename = this.getSuffix(url, filename)
            this.getBlob(url, (blob) => {
                this.saveAs(blob, filename)
            })
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
        getDetail() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/inspectioninfo/info/" + this.inspectionId,
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.dataForm = data.body;
                    if (!this.dataForm.inspectionMan) {
                        this.dataForm.inspectionMan = $common.getItem("userName");
                    }
                }
            });
        },
        // 删除封闭相关文件
        delCloseFile(index) {
            let _closeFileList = this.dataForm.closeFileList;
            _closeFileList.splice(index, 1);
            this.dataForm.closeFileList = _closeFileList;
        },
        // 删除封闭相关图片
        delClosePhoto(index) {
            let _closePhotoList = this.dataForm.closePhotoList;
            _closePhotoList.splice(index, 1);
            this.dataForm.closePhotoList = _closePhotoList;
        },
        // 上传照片
        uploadImg(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            this.$refs.uploadImg.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/10/0",
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            ).then(res => {
                res = res.data
                if (res.resultCode == 200) {
                    this.dataForm.closePhotoList.push({
                        inspectionId: this.inspectionId,
                        recFileType: '1',
                        fileName: res.body.fileName,
                        filePath: res.body.fileSavePath,
                        fileUri: res.body.fileUri,
                        fileContent: this.extractFileName(res.body.fileName),
                        thumbnailPath: res.body.thumbnailPath,
                        thumbnailPathUri: res.body.thumbnailPathUri,
                        compressedPath: res.body.compressedPath,
                        synchroFlg: '0'
                    });
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        // 上传文件
        uploadFile(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            this.$refs.uploadFile.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/10/0",
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            ).then(res => {
                res = res.data
                if (res.resultCode == 200) {
                    this.dataForm.closeFileList.push({
                        inspectionId: this.inspectionId,
                        recFileType: '2',
                        fileName: this.extractFileName(res.body.fileName),
                        filePath: res.body.fileSavePath,
                        fileUri: res.body.fileUri
                    });
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        beforeUploadSituation(file) {
            const isValidType = file.type === 'image/jpeg' ||
                file.type === 'image/png' ||
                file.type === 'image/jpg'

            if (!isValidType) {
                this.$message.error('只能上传 JPG/PNG 格式的图片！')
                return false
            }
            return true
        },
        extractFileName(fileName) {
            let index = fileName.lastIndexOf(".");
            return fileName.substr(0, index)
        },
        dataFormSubmit() {
            if (this.closeFlg == false) {
                if (this.dataForm.closeTime == null || this.dataForm.closeTime == '') {
                    this.$message.error("请输入封闭时间！")
                    return;
                }
                if (this.dataForm.closeMan == null || this.dataForm.closeMan == '') {
                    this.$message.error("请输入封闭人！")
                    return;
                }
            }
            this.dataForm.inspectionId = this.inspectionId
            let _url = "/business/inspectioninfo/closeInspection";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData(this.dataForm)
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.closeFlg = false
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                            // 数据更新成功后，触发事件通知父组件刷新数据
                            this.$emit('refreshDataList');
                        }
                    });
                }
            });
        },
        cancelClose() {
            this.$confirm(`确定要取消封闭吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: this.$store.state.httpUrl + "/business/inspectioninfo/cancelCloseInspection/" + this.dataForm.inspectionId,
                    method: 'post',
                    params: {}
                }).then(({
                    data
                }) => {
                    if (data && data.resultCode === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false;
                                // 数据更新成功后，触发事件通知父组件刷新数据
                                this.$emit('refreshDataList');
                            }
                        })
                    }
                })
            });
        }
    }
};
</script>

<style scoped="scoped">
.addImgBox {
    width: 180px;
    height: 180px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 23px;
}

.set_title {
    margin-left: 10px;
    margin-bottom: 10px;
}

.upload-demo /deep/ .el-upload-dragger {
    width: 260px;
    height: 185px;
}

.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
    font-size: 40px;
    margin: 0 0;
    line-height: 40px;
    padding-top: 45px
}

.upload-demo /deep/ .el-upload-dragger .el-upload__text {
    line-height: 20px;
}

.no-border-input /deep/ .el-input__inner {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid #dcdfe6 !important;
    /* Element原生默认边框色 */
    border-radius: 0 !important;
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 10px !important;
    box-shadow: none !important;
    outline: none !important;
}

/* textarea完全同规 - 原生默认+仅底部边框 */
.no-border-input /deep/ .el-textarea__inner {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid #dcdfe6 !important;
    /* Element原生默认边框色 */
    border-radius: 0 !important;
    padding: 5px 10px !important;
    resize: none;
    box-shadow: none !important;
    outline: none !important;
}

/* 焦点状态 - 仅改Element原生主题色，不加粗、无阴影、无任何额外样式 */
.no-border-input /deep/ .el-input__inner:focus {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid #409eff !important;
    /* Element原生焦点色，1px不变 */
    box-shadow: none !important;
    outline: none !important;
}

/* textarea焦点完全同规 - 仅改色，不加粗 */
.no-border-input /deep/ .el-textarea__inner:focus {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid #409eff !important;
    /* Element原生焦点色，1px不变 */
    box-shadow: none !important;
    outline: none !important;
}

/* 隐藏日期选择器的图标 */
.no-border-input.el-date-editor.el-date-editor--date /deep/ .el-input__prefix {
    display: none !important;
}

.no-border-input.el-date-editor.el-date-editor--date /deep/ .el-input__inner {
    border: none !important;
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 10px !important;
    /* 恢复正常内边距 */
    background-color: transparent !important;
}

.row-form-item .el-form-item {
    margin-right: 0px;
    margin-bottom: 0px;
}


.fileItem::v-deep .el-form-item__label {
    text-align: right;
    color: #00428e !important;
    font-weight: bold !important;
    width: 100% !important;
    height: 20px !important;
    display: flex;
    align-items: center;
}

.border-form .el-row.set_border {
    border-bottom: 0.5px solid #dadada;
    border-left: 0.5px solid #dadada;
    border-right: 0.5px solid #dadada;
}

.border-form .el-row.set_border:first-child {
    border-top: 0.5px solid #dadada;
}

.border-form .el-row.set_border .col-set_border {
    border-right: 0.5px solid #dadada;
}

.item::v-deep .el-form-item__label {
    color: #00428e !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    background-color: #E1F1FF;
    height: 40px !important;
    /* border-right: 1px solid #dadada; */
}

.col-set_border .el-form-item {
    margin-right: 0px;
    margin-bottom: 0px;
}

.set_data {
    display: inline-block;
    line-height: 1.4;
    font-weight: bold !important;
    margin: 0 !important;
    padding: 2px 5px !important;
    min-height: 60px;
    font-size: 12px;
    height: auto;

}

.fileItem {
    max-height: 40px !important;
}

::v-deep(.upload-demo-photo .el-upload-dragger) {
    width: 915px;
    height: 100px;
    margin-bottom: -30px;
}

::v-deep(.upload-demo-photo .el-upload-dragger .el-icon-upload) {
    font-size: 30px;
    margin: 20px 1px;
    line-height: 20px;
}

::v-deep(.upload-demo-photo .el-upload-dragger .el-upload__text) {
    line-height: 5px;
}
</style>
